export const SCHEDA_ENTE_STATE = {
  BOZZA: 1,
  ACCREDITATO: 2,
  DISATTIVATA: 4,
  IN_COMPILAZIONE: 21,
  COMPILATA: 22,
  DA_CORREGGERE: 30,
  VALIDATA: 31,
};
